const buttonLoader = {
  start(button: HTMLAnchorElement | HTMLButtonElement): void {
    button.classList.add('button--loading', 'button--disabled')
    button.setAttribute('disabled', 'true')
  },

  reset(button: HTMLAnchorElement | HTMLButtonElement): void {
    button.classList.remove('button--loading', 'button--disabled', 'button--success', 'button--error')
    button.removeAttribute('disabled')
  },

  success(button: HTMLAnchorElement | HTMLButtonElement): void {
    button.classList.remove('button--loading', 'button--disabled')
    button.classList.add('button--success')
    button.removeAttribute('disabled')

    setTimeout(() => {
      this.reset(button)
    }, 750)
  },

  error(button: HTMLAnchorElement | HTMLButtonElement): void {
    button.classList.remove('button--loading', 'button--success')
    button.classList.add('button--error')

    setTimeout(() => {
      this.reset(button)
    }, 750)
  },
}

export default buttonLoader
